/* Temas sin publicar (staging, desarrollo): la obra nueva (v2, con el configurador) activa por defecto en todo el sitio,
   para enseñarle al cliente el sitio completo con el link de preview. ?fr_v2=0 la apaga en esa pestaña (?fr_v2=1 la
   vuelve a prender). Nunca corre en el tema en vivo. */
(() => {
  const theme = window.Shopify && Shopify.theme;
  if (!theme || theme.role === 'main') return;
  const flag = new URLSearchParams(location.search).get('fr_v2');
  let isOn = flag !== '0';
  try {
    if (flag === '0' || flag === '1') sessionStorage.setItem('fr_v2', flag);
    isOn = sessionStorage.getItem('fr_v2') !== '0';
  } catch (e) { /* sin sessionStorage: manda el parámetro de esta página */ }
  if (!isOn) return;

  // La obra con la plantilla de siempre se cambia por la v2, conservando variante y demás parámetros.
  if (document.body.classList.contains('fr-t-product')) {
    const url = new URL(location.href);
    url.searchParams.set('view', 'v2');
    location.replace(url);
    return;
  }
  const relink = () => document.querySelectorAll('a[href*="/products/"]').forEach((a) => {
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin || url.searchParams.has('view') || !/^\/products\/[^/.]+$/.test(url.pathname)) return;
    url.searchParams.set('view', 'v2');
    a.href = url.pathname + url.search + url.hash;
  });
  relink();
  // Tarjetas que llegan después (filtros, "Cargar más", búsqueda): solo cambios de nodos, no de estilos.
  new MutationObserver(relink).observe(document.body, { childList: true, subtree: true });
})();

/* Navegación lenta: si la página siguiente tarda más de medio segundo, aparece el marco de carga (fr-motion.css).
   Va aparte y antes del resto porque es aviso de carga, no adorno: también corre con movimiento reducido. */
(() => {
  const SLOW_MS = 500, GIVE_UP_MS = 12000;
  let timer;
  const stop = () => { clearTimeout(timer); document.documentElement.classList.remove('fr-navigating'); };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if ((link.target && link.target !== '_self') || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || (url.pathname === location.pathname && url.search === location.search)) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      // Otros scripts (filtros, carrito, modal) pueden cancelar el link: entonces no hay navegación que esperar.
      if (event.defaultPrevented) return;
      document.documentElement.classList.add('fr-navigating');
      timer = setTimeout(stop, GIVE_UP_MS);
    }, SLOW_MS);
  });
  addEventListener('pageshow', stop);   // al volver con "atrás" (bfcache) no debe quedar puesto
  addEventListener('pagehide', stop);

  // "Cargar más": load-more.js oculta el botón tanto al pedir la página como cuando ya no hay más, así que el marco
  // solo se muestra entre el click y el fin de la petición de jQuery (ajaxComplete corre después de .done y .fail).
  document.addEventListener('click', (event) => {
    if (event.target.classList.contains('load-more-btn')) event.target.parentElement.classList.add('fr-loading-more');
  }, true);
  if (window.jQuery) jQuery(document).on('ajaxComplete', () => jQuery('.fr-loading-more').removeClass('fr-loading-more'));

  // Filtros: facets.js pone .loading en la colección y Webflow abre el cajón con un style en línea. Se reflejan como clases
  // en <html> para que el CSS no necesite :has() sobre body (ver fr-motion.css, sección Carga).
  const grid = document.getElementById('ProductGridContainer');
  const root = document.documentElement;
  const sync = () => {
    root.classList.toggle('fr-filtering', !!grid?.querySelector('.collection.loading'));
    root.classList.toggle('fr-drawer-open', !!document.querySelector('.filter-dropdown-drawer[style*="display: block"]'));
  };
  if (grid) new MutationObserver(sync).observe(grid, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  document.querySelectorAll('.filter-dropdown-drawer').forEach((drawer) => {
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['style'] });
  });

  // Pastillas de filtro: is-checked en lugar de :has(input:checked) (Liquid lo pone al renderizar; aquí al marcar).
  document.addEventListener('change', (event) => {
    if (event.target.matches('.fr-pill input')) event.target.closest('.fr-pill').classList.toggle('is-checked', event.target.checked);
  });
})();

/* Entradas al hacer scroll en todo el sitio (estilos en fr-motion.css).
   Solo se ocultan los elementos que están debajo de la pantalla al cargar: lo visible nunca parpadea y sin JS todo
   se ve normal. Las zonas con movimiento propio (galería, obra v2, configurador, certificado, registro) quedan fuera. */
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;

  // La franja de datos debajo del configurador (.fr-pdp--facts) sí entra con el resto.
  const OWN_MOTION = '#ProductGridContainer, .fr-pdp:not(.fr-pdp--facts), .fr-cfg, .fr-cert-page, .fr-registry-section, [class*="dashboard"]';
  // .w-slider y el marquee se revelan enteros: sus piezas ya se mueven solas.
  const ITEMS = '.w-slider, [class*="marquee"], .collection-card, .image-wrapper, img, h1, h2, h3, h4, h5, h6, p, .button, li, .newsletter-wrapper form';
  // Un transform convierte al elemento en el marco de sus hijos fijos (el modal viejo de las tarjetas): ahí solo opacidad.
  const HAS_FIXED = '.modal, .product-card, .w-dropdown';
  const STEP = 0.07, MAX_DELAY = 0.42, CLEANUP_MS = 1400, OPENING_MS = 900;

  // El newsletter vive en el grupo del footer, fuera de <main>.
  const sections = [...document.querySelectorAll('main > .shopify-section, body > .shopify-section[id*="newsletter"]')]
    .filter((s) => !s.matches(OWN_MOTION) && !s.querySelector(OWN_MOTION));

  const kind = (el) => {
    // El parallax (GSAP) escribe el transform de la foto en cada cuadro: una transición encima lo haría flotar.
    if (el.matches('.image-wrapper') && getComputedStyle(el).overflow === 'hidden' && el.querySelector('img')
      && !el.querySelector('.is-parallax')) return 'image';
    return el.querySelector(HAS_FIXED) ? 'fade' : 'rise';
  };

  const reveal = (el, i) => {
    el.style.setProperty('--fr-d', `${Math.min(i * STEP, MAX_DELAY)}s`);
    el.classList.remove('fr-hide');
    // Se quita la marca al terminar para no dejar transiciones sobre el parallax o el cambio de foto de las tarjetas.
    setTimeout(() => { el.removeAttribute('data-fr-reveal'); el.style.removeProperty('--fr-d'); }, CLEANUP_MS + i * STEP * 1000);
  };

  // Margen superior enorme: lo que quedó arriba por un salto (ancla, tecla Fin) también cuenta como visto.
  const io = new IntersectionObserver((entries) => {
    entries.filter((e) => e.isIntersecting)
      .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left)
      .forEach((e, i) => { io.unobserve(e.target); reveal(e.target, i); });
  }, { rootMargin: '1000000px 0px -8% 0px' });

  // Primero se lee todo y después se escribe: intercalarlos forzaría un recálculo de estilos por elemento.
  const fold = innerHeight;
  const hidden = sections.flatMap((section) => [...section.querySelectorAll(ITEMS)].filter((el) => {
    if (section.contains(el.parentElement.closest(ITEMS))) return false;   // solo el de más arriba
    const box = el.getBoundingClientRect();
    return box.height > 0 && box.top >= fold;   // oculto o ya a la vista: no se toca
  })).map((el) => [el, kind(el)]);
  hidden.forEach(([el, k]) => {
    el.setAttribute('data-fr-reveal', k);
    el.classList.add('fr-hide');
    io.observe(el);
  });

  // Registro de la edición: las casillas se llenan en cascada al entrar a la pantalla (fr-certificate.css).
  const cells = new IntersectionObserver((entries) => entries.filter((e) => e.isIntersecting).forEach((e) => {
    cells.unobserve(e.target);
    e.target.classList.replace('fr-wait', 'is-in');
  }), { rootMargin: '1000000px 0px -10% 0px' });
  document.querySelectorAll('.fr-registry').forEach((reg) => {
    if (reg.getBoundingClientRect().top < fold) return;   // ya a la vista: se queda quieto, sin parpadeo
    reg.classList.add('fr-wait');
    cells.observe(reg);
  });

  // Cajón de Filtrar: .fr-opening mientras abre, para que la cascada no se repita cuando facets.js reemplaza los grupos.
  document.querySelectorAll('.filter-dropdown-drawer').forEach((drawer) => {
    let wasOpen = drawer.style.display === 'block', timer;
    new MutationObserver(() => {
      const isOpen = drawer.style.display === 'block';
      if (isOpen && !wasOpen) {
        drawer.classList.add('fr-opening');
        clearTimeout(timer);
        timer = setTimeout(() => drawer.classList.remove('fr-opening'), OPENING_MS);
      }
      wasOpen = isOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['style'] });
  });
})();

/* Hero del home: al bajar, la foto se mueve más lento que la página (parallax) y el texto sube y se desvanece.
   La entrada al cargar es solo CSS (fr-motion.css). */
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const hero = document.querySelector('body.fr-t-index main > .shopify-section:first-child .is-hero');
  const slide = hero && hero.querySelector('.w-slide');
  const media = slide && slide.querySelector('.image-wrapper.is-background');
  const text = slide && slide.querySelector('.overlay-content');
  if (!media || !text) return;
  const PARALLAX = 0.25, TEXT_RISE_PX = 60, TEXT_FADE = 1.4;
  let last = -1, queued = false;
  const update = () => {
    queued = false;
    const h = hero.offsetHeight || 1;
    const p = Math.min(Math.max(scrollY / h, 0), 1);
    if (p === last) return;
    last = p;
    media.style.transform = `translate3d(0, ${(p * h * PARALLAX).toFixed(1)}px, 0)`;
    text.style.transform = `translate3d(0, ${(-p * TEXT_RISE_PX).toFixed(1)}px, 0)`;
    text.style.opacity = String(Math.max(0, 1 - p * TEXT_FADE));
  };
  addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
  update();
})();
